import { render, staticRenderFns } from "./tasksViewWork.vue?vue&type=template&id=c42e5daa&"
import script from "./tasksViewWork.vue?vue&type=script&lang=js&"
export * from "./tasksViewWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports